import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import http from "../../services/api";
import * as types from "../../store/types/usuario";

const newHttp = axios.create({ baseURL: http.defaults.baseURL });

export function LoginAppTokenPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token } = useParams();

  const [query] = useSearchParams({});

  const [error, setError] = useState(false);

  async function VerifyAppToken(token: string) {
    localStorage.removeItem("token");

    return newHttp
      .get("/api/v2/app/cliente/usuario-logado", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        dispatch({
          type: types.USUARIO_SET,
          payload: { ...response.data, token },
        });

        localStorage.setItem("token", token);
        navigate("/app/pagamentocadastro");

        // const redirect = query.get("redirect");
        // const url =
        //   !redirect || redirect === "" || redirect === "undefined"
        //     ? "/perfil"
        //     : redirect;
        // window.location.href = "https://api.whatsapp.com/send?phone=5516999091000&text=%20Ol%C3%A1,%20gostaria%20de%20saber%20mais%20sobre%20o%20plano%20Fynd%20Fam%C3%ADlia%20de%20R$69,90"
      })
      .catch(() => {
        setError(true);
      });
  }

  useEffect(() => {
    if (!query) {
      return navigate("/");
    }

    VerifyAppToken(token).catch(() => setError(true));
  }, [query]);

  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        flexFlow: "column nowrap",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {error ? (
        <div>
          <h2>Não foi possível realizar a autenticação.</h2>
          <h3>Tente novamente mais tarde ou entre em contato com o suporte.</h3>
        </div>
      ) : (
        <div>
          <h2>Verificando autenticação...</h2>
          <h3>Logo você será redirecionado</h3>
        </div>
      )}
    </div>
  );
}
